<script lang="ts" setup>
import AutoBookDialog from './AutoBookDialog.vue'
import { useContainerStore } from '~/stores/containers'
import { useContainerFilters } from '~/compositions/containerFilters'

const { pageSize } = useContainerFilters()

const dialogOpen = ref(false)
const autoBookDialogOpen = ref(false)
const autoBookContainerNumbers = ref<string[]>([])

const containerStore = useContainerStore()

function handleOpenAutoBook(containerNumbers: string[]) {
  autoBookContainerNumbers.value = containerNumbers
  autoBookDialogOpen.value = true
}

function handleAutoBookClose() {
  autoBookDialogOpen.value = false
  autoBookContainerNumbers.value = []
}

// Get container objects for auto book dialog
const autoBookContainers = computed(() => {
  return autoBookContainerNumbers.value
    .map((number) => containerStore.containerLookup.get(number))
    .filter(
      (container): container is NonNullable<typeof container> =>
        container !== undefined
    )
})

const loading = computed(() => {
  return (
    autoBookContainerNumbers.value.length > autoBookContainers.value.length &&
    !(
      autoBookContainerNumbers.value.length > pageSize.value &&
      autoBookContainers.value.length === pageSize.value
    )
  )
})
</script>

<template>
  <el-button
    v-bind="$attrs"
    type="primary"
    class="fs-open-upload-containers-via-spreadsheet adjust-button-height"
    @click="dialogOpen = true"
  >
    <i-mdi:upload class="align-text-bottom mr-1" />
    Add Containers
  </el-button>
  <AddContainersDialog
    v-if="dialogOpen"
    v-model="dialogOpen"
    @open-auto-book="handleOpenAutoBook"
  />
  <AutoBookDialog
    v-if="autoBookDialogOpen && autoBookContainers.length > 0 && !loading"
    :containers="autoBookContainers"
    @close="handleAutoBookClose"
  />
</template>

<style scoped lang="scss">
.method-header {
  @apply text-center my-3 text-lg font-semibold;
}

.adjust-button-height {
  height: 40px;
}
</style>
